import React, { useEffect, useState } from "react";
import { UserAuth } from "../Context";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
import {
  deleteShoppingListFromAlgolia,
  saveShoppingListToAlgolia,
} from "../lib/algoliaFunctions";

const PrivacyControls = ({ closeTray, selectedShopList }) => {
  const { user } = UserAuth();
  const visibilityLevels = ["Public", "Friends", "Private"];
  const visibilityOptions = {
    Public: "(Anyone can view and comment)",
    Friends: "(Invited Friends according to roles)",
    Private: "(Only You can perform actions)",
  };
  const [visibility, setVisibility] = useState(visibilityLevels[0] || "");

  const fetchVisibility = async () => {
    if (!user || !selectedShopList) return;

    // Reference to the shoppingList subcollection document
    const shoppingListDocRef = doc(
      db,
      "users",
      user?.uid,
      "shoppingList",
      selectedShopList
    );
    const shoppingListDocSnap = await getDoc(shoppingListDocRef);

    if (!shoppingListDocSnap.exists()) {
      console.log("No such document in shoppingList subcollection!");
      return; // Early return if shopping list document does not exist
    }

    // Extract visibility from the shopping list document
    const visibilityFromDB =
      shoppingListDocSnap?.data()?.visibility || visibilityLevels[0];
    setVisibility(visibilityFromDB);
  };

  useEffect(() => {
    fetchVisibility();
    // eslint-disable-next-line
  }, [selectedShopList, user]);

  const handleClick = async () => {
    try {
      // Reference to the specific document in the shoppingList subcollection
      const shoppingListDocRef = doc(
        db,
        "users",
        user?.uid,
        "shoppingList",
        selectedShopList
      );

      // Read the document
      const docSnap = await getDoc(shoppingListDocRef);

      if (!docSnap.exists()) {
        console.log("No such document!");
      } else {
        if (visibility === "Public") {
          console.log("saving list to algolia");
          saveShoppingListToAlgolia(user, docSnap?.id);
        } else {
          console.log("deleting list from algolia");
          deleteShoppingListFromAlgolia(docSnap?.data()?.listId);
        }
        // Update the visibility property within the specific document
        await updateDoc(shoppingListDocRef, {
          visibility: visibility, // Set the visibility to the desired value
        });
        toast.success(`Settings has been updated`, toastOptions);
        console.log("Document successfully updated with new visibility!");
      }
      closeTray();
    } catch (error) {
      console.error("Error updating visibility: ", error);
    }
  };
  return (
    <>
      <div>
        <Form
          onClick={(e) => e.stopPropagation()}
          style={{
            backgroundColor: "white",
            padding: "16px",
            borderRadius: "8px",
          }}
        >
          {Object.entries(visibilityOptions).map(([level, label]) => (
            <div key={level} className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id={level}
                name="visibility"
                value={level}
                checked={visibility === level}
                onChange={(e) => setVisibility(e.target.value)}
              />
              <label
                className="form-check-label"
                style={{
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: "16px",
                  color: "#676A79",
                }}
                htmlFor={level}
              >
                {level} {label}
              </label>
            </div>
          ))}
        </Form>
        <div className="d-flex flex-column gap-2 w-100">
          <Button
            className="rounded-3"
            variant="primary"
            onClick={async () => {
              handleClick();
              closeTray();
            }}
          >
            Done
          </Button>
        </div>
      </div>
    </>
  );
};

export default PrivacyControls;
